
import { useWallet } from '@solana/wallet-adapter-react';
import { formatWalletAddress } from '../utils/phantomUtils';
import { useWalletState } from './useWalletState';
import { useWalletHandlers } from './useWalletHandlers';

/**
 * Main wallet connection hook that combines wallet state and handlers
 */
export const useWalletConnection = () => {
  const { publicKey, connected, wallet, wallets } = useWallet();
  const { balance } = useWalletState();
  const { handleConnect, handleDisconnect, openWalletModal, connecting } = useWalletHandlers();
  
  // Format the wallet address for display
  const formattedAddress = publicKey ? formatWalletAddress(publicKey.toString()) : '';

  return {
    wallet,
    wallets,
    publicKey,
    connected,
    connecting,
    handleConnect,
    handleDisconnect,
    formattedAddress,
    balance,
    openWalletModal,
  };
};
